import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HealthCheckService {
    private readonly httpClient = inject(HttpClient);
    private readonly router = inject(Router);

    ping(): Observable<unknown> {
        return this.httpClient.skipToken().skipErrorHandler().get('sxAk/ping');
    }

    check(): void {
        this.ping()
            .pipe(
                catchError(() => {
                    this.router.navigateByUrl('/maintenance');
                    return EMPTY;
                }),
            )
            .subscribe();
    }
}
